import type { IconButtonProps as SystemIconButtonProps } from '@hover/blueprint';
import { IconButton as SystemIconButton, forwardRef } from '@hover/blueprint';
import React from 'react';

import { useTracking } from 'src/shared/hooks';
import type { UseTrackingProps } from 'src/shared/hooks/useTracking';

export interface ButtonProps
  extends SystemIconButtonProps,
    Omit<UseTrackingProps, 'buttonText'> {}

const IconButton = forwardRef<ButtonProps, 'button'>(
  (
    {
      pageName,
      primaryCallToAction = false,
      buttonLocation,
      label,
      onClick,
      track,
      type: _type,
      optionalTrackingProperties = {},
      ...props
    },
    ref,
  ) => {
    const { onClick: onClickWithTracking } = useTracking({
      buttonLocation,
      buttonText: label,
      optionalTrackingProperties,
      pageName,
      primaryCallToAction,
      track,
    });

    return (
      <SystemIconButton
        {...props}
        label={label}
        onClick={event => {
          onClick?.(event);
          onClickWithTracking(event);
        }}
        ref={ref}
      />
    );
  },
);

export { IconButton };
